import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import type { AppProfile } from "@/lib/appProfile";
import {
  deleteCurrentProfile,
  getCurrentProfileRecord,
  updateCurrentProfile,
} from "@/lib/profileClient";
import { queryKeys } from "@/lib/queryKeys";

export type UseCurrentProfileQueryOptions = {
  /** When false, the profile request is not sent (use with `initialProfile` for local-only flows). */
  enabled?: boolean;
};

export function useCurrentProfileQuery(
  initialProfile?: AppProfile,
  options?: UseCurrentProfileQueryOptions,
) {
  return useQuery({
    queryKey: queryKeys.profile.current(),
    queryFn: getCurrentProfileRecord,
    initialData: initialProfile,
    enabled: options?.enabled ?? true,
  });
}

export function useUpdateCurrentProfileMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCurrentProfile,
    onSuccess(updatedProfile) {
      queryClient.setQueryData(queryKeys.profile.current(), updatedProfile);
    },
  });
}

export function useDeleteCurrentProfileMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCurrentProfile,
    onSuccess() {
      queryClient.clear();
    },
  });
}
